var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tags && _vm.tags.length)?_c('div',{staticClass:"public-tags"},_vm._l((_vm.tags),function(tag){return _c('button',{key:tag,staticClass:"public-tags__tag",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('select', tag)}}},[_vm._v(_vm._s(tag))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }